import { createAction } from '@reduxjs/toolkit';
import { ABTUnknownFlags } from '@yandex-int/abt/build/types';

export const setExperiments = createAction(
    '@@experiments/SET_EXPERIMENTS',
    (payload: Partial<ABTUnknownFlags>) => ({ payload }),
);
